export const usdotRegex = /^\d+$/;